export const spacingMedium = 12;
